module.exports = __webpack_public_path__ + "img/password.af08944b.svg";